import React from 'react'

import { showLogin } from '../../libs/authService'
import { DEFAULT_PROFILE_PIC_SRC, ALL_LANGUAGES } from './../../constants'
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'
import { translate } from 'react-i18next'

import Modal from 'react-bootstrap-modal'
import { SocialIcon } from 'react-social-icons'
import whatsappIcon from '../../../public/img/GuruProfile/whatsapp.svg'
import copyLinkIcon from '../../../public/img/GuruProfile/copyLink.png'

const host = '//' + window.location.hostname + (window.location.port != 80 ? ':' + window.location.port : '')

class GuruProfileAbout extends React.Component {
  state = {
    isShowShareModal: false,
    isSuccess: false,
    currentLink: null
  }

  componentWillUnmount() {
    document.removeEventListener('copy', e => {
      e.clipboardData.setData('text/plain')
      e.preventDefault() // default behaviour is to copy any selected text
    })
  }

  handleClose = () => {
    this.setState({ isShowShareModal: false })
  }

  handleShow = () => {
    this.setState({ isShowShareModal: true })
  }

  searchLanguaegs = langId => {
    return ALL_LANGUAGES.filter(lang => {
      if (lang['1'] === langId) {
        return lang.name
      } else {
        return null
      }
    })
  }

  renderLanguages = () => {
    let { languages } = this.props.user[0].plannerProfile
    let string
    if (JSON.parse(languages).length > 1) {
      const langArray = JSON.parse(languages).map(langId => this.searchLanguaegs(langId)[0].name)
      string = langArray.slice(0, -1).join(', ') + ' and  ' + langArray[langArray.length - 1]
    } else {
      string = ALL_LANGUAGES[JSON.parse(languages)[0]]
    }
    return string;
  }

  handleMessageClick = () => {
    if (!window.localStorage.auth0IdToken) {
      window.localStorage.setItem('authRedirect', window.location.pathname)
      showLogin()
    } else {
      this.props.showChatBox()
    }
  }

  handleShare = () => {
    this.handleShow()
  }

  handleClipBoard = text => {
    document.addEventListener('copy', e => {
      e.clipboardData.setData('text/plain', text)
      e.preventDefault() // default behaviour is to copy any selected text
    })

    document.execCommand('copy')

    this.setState({
      isSuccess: true,
      currentLink: text
    })
  }

  copySuccess = () => {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: 15,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-around'
        }}
      >
        {`Link copied`}
        <code>{this.state.currentLink}</code>
      </div>
    )
  }

  renderModal = () => {
    return (
      <Modal
        show={this.state.isShowShareModal}
        onHide={this.handleClose}
        className="copy-modal"
        aria-labelledby="ModalHeader"
        style={{ paddingBottom: 25 }}
      >
        <Modal.Header closeButton={true}>
          <Modal.Title
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-around'
            }}
          >
            Share it with your friends
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-around',
              paddingBottom: 15
            }}
          >
            <div>
              <FacebookShareButton
                url={
                  this.props.guruId ? `${host}/gurus/guru-profile/${this.props.guruId}` : `${host}/gurus/guru-profile/${this.props.user.id}`
                }
              >
                <SocialIcon network="facebook" color="#4168AD" />
              </FacebookShareButton>
            </div>
            <div>
              <TwitterShareButton
                //title={ this.props.guruId ? `${host}/gurus/guru-profile/${this.props.guruId}` : `${host}/gurus/guru-profile/${this.props.user.id}`}
                url={
                  this.props.guruId ? `${host}/gurus/guru-profile/${this.props.guruId}` : `${host}/gurus/guru-profile/${this.props.user.id}`
                }
                hashtags={['GetTrip.Guru']}
              >
                <SocialIcon network="twitter" color="#00A2EC" />
              </TwitterShareButton>
            </div>
            <div>
              <WhatsappShareButton
                url={
                  this.props.guruId ? `${host}/gurus/guru-profile/${this.props.guruId}` : `${host}/gurus/guru-profile/${this.props.user.id}`
                }
                hashtags={['GetTrip.Guru']}
              >
                <img src={whatsappIcon} style={{ width: 50, height: 50 }} alt="" />
              </WhatsappShareButton>
            </div>
            <div style={{ cursor: 'pointer' }}>
              <img
                src={copyLinkIcon}
                style={{ width: 50, height: 50 }}
                alt=""
                onClick={() =>
                  this.props.guruId
                    ? this.handleClipBoard(`${host}/gurus/guru-profile/${this.props.guruId}`)
                    : this.handleClipBoard(`${host}/gurus/guru-profile/${this.props.user.id}`)
                }
              />
            </div>
          </div>

          {this.state.isSuccess && this.copySuccess()}
        </Modal.Body>
      </Modal>
    )
  }

  render() {
    const { userProfile, plannerProfile } = this.props.user[0]
    const { t } = this.props
    return (
      <div className="guru-profile__about-block">
        <div className="guru-profile__about-header">
          <img src={userProfile[0] && userProfile[0].imageAvatar ? userProfile[0].imageAvatar.s3Url : DEFAULT_PROFILE_PIC_SRC} className="guru-profile__avatar" alt="" />
          <div className="guru-profile__about-header-right">
            <div className="guru-profile__name-section">
              <div className="guru-profile__name">{userProfile[0].firstName}</div>
              <div className="guru-profile__description">{this.props.t('your_profile_summary_title')}</div>
            </div>
            <div className="guru-profile__header-icons">
              {this.props.showChatBox && <span className="icon-email" onClick={this.handleMessageClick} />}
              <span className="icon-share" onClick={this.handleShare} />
              <span className="icon-like" />
            </div>
          </div>
        </div>
        <div className="guru-profile__about-body">
          <div>
            <div className="guru-profile__feature reviews-bar">
              <div className="guru-profile__feature-icon rating-stars">
                <span className="icon-star-filled" />
                <span className="icon-star-filled" />
                <span className="icon-star-filled" />
                <span className="icon-star-filled" />
                <span className="icon-star-filled" />
              </div>
              <span>{this.props.user[0].userProfile[0].reviews.length} {t('reviews')}</span>
            </div>
            <div className="guru-profile__feature">
              <div className="guru-profile__feature-icon">
                <span className="icon-language" />
              </div>
              <span>{this.renderLanguages()}</span>
            </div>
          </div>
          <h4 className="guru-profile__section-title">{t('what_will_you_get')}</h4>
          <div>
            <div className="guru-profile__feature">
              <div className="guru-profile__feature-icon">
                <span className="icon-trip-plan" />
              </div>
              <div>
                <span>{t('guru_including_title')}:</span>
                <ul>
                  <li>{t('tailored_itineraries')}</li>
                  <li>{t('information_advices')}</li>
                  <li>{t('tips_for')}</li>
                  <li>{t('food_suggestions')}</li>
                  <li>{t('special_events')}</li>
                  <li>{t('personal_app')}</li>
                </ul>
              </div>
            </div>
            <div className="guru-profile__feature">
              <div className="guru-profile__feature-icon">
                <span className="icon-speech-bubble" />
              </div>
              <div>
                <span>
                  {t('online_offering')}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="guru-profile__section">
          <h4 className="guru-profile__section-title">{t('about_me')}</h4>
          {plannerProfile.aboutMyself}
        </div>
        <div className="guru-profile__categories">
          <h4 className="guru-profile__section-title">Categories</h4>
          <div>
            {this.props.user[0] &&
              JSON.parse(this.props.user[0].plannerProfile.categories).map((categorie, index) => (
                <span key={index}>
                  {this.props.user[0].plannerProfile.categories.length > 1
                    ? `${t('categories:' + categorie)}${index < this.props.user[0].plannerProfile.categories.length - 1 ? ',' : ''} `
                    : t('categories:' + categorie)}
                </span>
              ))}
          </div>
        </div>

        {this.props.user &&
          this.props.user.plannerProfile &&
          this.props.user.plannerProfile.expertises && (
            <div className="guru-profile__categories" style={{ borderTop: 0 }}>
              <h4 className="guru-profile__section-title">Special Expertise</h4>
              <div>
                {this.props.user[0] &&
                  JSON.parse(this.props.user[0].plannerProfile.expertises).map((expertise, index) => (
                    <span key={index}>
                      {this.props.user[0].plannerProfile.expertises.length > 1
                        ? `${expertise}${index < this.props.user[0].plannerProfile.expertises.length - 1 ? ',' : ''} `
                        : expertise}
                    </span>
                  ))}
              </div>
            </div>
          )}

        {this.renderModal()}
      </div>
    )
  }
}

export default translate('guru')(GuruProfileAbout)



// WEBPACK FOOTER //
// src/components/Guru/GuruProfileAbout.jsx